import { render } from "./visual-facet.vue?vue&type=template&id=30360fc3"
import script from "./visual-facet.vue?vue&type=script&lang=js"
export * from "./visual-facet.vue?vue&type=script&lang=js"

import "./visual-facet.vue?vue&type=style&index=0&id=30360fc3&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__